import React, {useContext} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';


export function DriverListSelect({attr, additionalOptions, ...props}) {

  const applicationModel = useContext(ModelContext);
  const drivers = applicationModel.getValue('drivers');

  let driverOptions = drivers ? drivers.filter(driver => {
    return driver.status === 'Active';
  }).map(driver => {
        return ({
          value: `${driver.nameInfo.surname}, ${driver.nameInfo.givenName}`,
          name: `${driver.nameInfo.surname}, ${driver.nameInfo.givenName}`
        })
  }) : [];

  if (additionalOptions && additionalOptions.length) {
    driverOptions = [...driverOptions, ...additionalOptions];
  }

  return <PortalSelect {...props}>
    {
      driverOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

DriverListSelect.schema = BASIC_ELEMENT_SCHEMA;